import * as React from 'react';
import dayjs from 'dayjs';
import { GridCustomCellProps } from '@progress/kendo-react-grid';

export default class LocalDateCell extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field || this.props.rowType !== 'data') return null;

    const field = this.props.dataItem[this.props.field];

    return (
      <td {...this.props.tdProps}>
        {field ? dayjs.utc(field).tz(dayjs.tz.guess()).format("MM/DD/YYYY HH:mm z") : ''}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return this.props.dataItem[this.props.field] !== nextProps.dataItem[this.props.field];
  }
}
